import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthRoute } from '@portal-core/auth/enums/auth-route.enum';
import { AuthRouteService } from '@portal-core/auth/services/auth-route.service';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { Observable, catchError, map, of } from 'rxjs';

export const subdomainGuard: CanActivateFn = (): Observable<boolean> => {
  const authService = inject(AuthService);
  const authRouteService = inject(AuthRouteService);

  // Route guards can be called multiple times as navigation occurs. Check if the subdomain has already been validated before doing the work to validate it.
  if (authService.hasValidatedSubdomain()) {
    return of(authService.isValidSubdomain());
  }

  return authService.getSubdomainLicense$().pipe(
    map(license => {
      if (license) {
        return true;
      } else {
        authRouteService.navigateToAuthRoute$(AuthRoute.SubdomainGuardError).subscribe();
        return false;
      }
    }),
    catchError(() => {
      authRouteService.navigateToAuthRoute$(AuthRoute.SubdomainGuardError).subscribe();
      return of(false);
    })
  );
};
